import {MatDialog, MatDialogConfig} from '@angular/material';
import {ErrorComponent} from '../../popups/error/error.component';
import {SuccessComponent} from '../../popups/success/success.component';
import {ConfirmationComponent} from '../../popups/confirmation/confirmation.component';

export class MensajeUtils
{
  constructor(private matDialog: MatDialog)
  {

  }

  public mostrarMensajeError(mensajeError: string, aceptarHandler: () => void): void
  {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    matDialogConfig.minHeight = '10px';
    matDialogConfig.minWidth = '10px';
    matDialogConfig.disableClose = true;
    matDialogConfig.data = mensajeError;

    const errorMatDialogRef = this.matDialog.open(ErrorComponent, matDialogConfig);
    errorMatDialogRef.afterClosed().subscribe(aceptar =>
    {
      if (aceptar === true)
      {
        if (aceptarHandler !== null)
        {
          aceptarHandler();
        }
      }
    });
  }

  public mostrarMensajeInformacion(mensajeInformacion: string, aceptarHandler: (paramAceptar: any) => void, paramAceptarHandler: any): void
  {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    matDialogConfig.minHeight = '10px';
    matDialogConfig.minWidth = '10px';
    matDialogConfig.disableClose = true;
    matDialogConfig.data = mensajeInformacion;

    const successMatDialogRef = this.matDialog.open(SuccessComponent, matDialogConfig);
    successMatDialogRef.afterClosed().subscribe(aceptar =>
    {
      if (aceptar === true)
      {
        if (aceptarHandler !== null)
        {
          aceptarHandler(paramAceptarHandler);
        }
      }
    });
  }

  public mostrarMensajeConfirmacion(mensajeConfirmacion: string, aceptarHandler: (paramAceptar: any) => void,
                                    paramAceptarHandler: any, cancelarHandler: () => void): void
  {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    matDialogConfig.minHeight = '10px';
    matDialogConfig.minWidth = '10px';
    matDialogConfig.disableClose = true;
    matDialogConfig.data = mensajeConfirmacion;

    const confirmationMatDialogRef = this.matDialog.open(ConfirmationComponent, matDialogConfig);
    confirmationMatDialogRef.afterClosed().subscribe(seConfirmo =>
    {
      if (seConfirmo === true)
      {
        if (aceptarHandler !== null)
        {
          aceptarHandler(paramAceptarHandler);
        }
      }
      else
      {
        if (cancelarHandler !== null)
        {
          cancelarHandler();
        }
      }
    });
  }
}
